import React from 'react';

import KoncertWiersz from '../components/koncerty/KoncertWiersz';
import KoncertyStrona from '../components/koncerty/KoncertyStrona';
import PotockLink from '../components/PotockLink';
import useKoncerty from '../hooks/useKoncerty';

/**
 * Nadchodzące koncerty. Lista przychodzi z builda (dla wyszukiwarek),
 * a po załadowaniu strony jest podmieniana na aktualną z API sklepu.
 */
function KoncertyPage({ pageContext }) {
  const { koncerty, wczytywanie } = useKoncerty(
    'upcoming',
    pageContext.koncerty
  );

  return (
    <KoncertyStrona
      tytul="Koncerty"
      opisSeo="Najbliższe koncerty zespołu Potock — terminy i miejsca."
      aktywnaZakladka="nadchodzace"
      wczytywanie={wczytywanie}
    >
      {koncerty.length > 0 ? (
        <ul className="koncerty-lista koncerty-lista--nadchodzace">
          {koncerty.map(koncert => (
            <KoncertWiersz key={koncert.id} koncert={koncert} />
          ))}
        </ul>
      ) : (
        !wczytywanie && (
          <div className="koncerty-pusto">
            <p className="mb-4">
              Nie mamy jeszcze potwierdzonych terminów najbliższych koncertów.
            </p>
            <p>
              Zajrzyj do{' '}
              <PotockLink to="/koncerty/archiwum">archiwum</PotockLink> albo
              napisz do nas na{' '}
              <a href="mailto:m.art.koncerty@gmail.com">
                m.art.koncerty@gmail.com
              </a>
              .
            </p>
          </div>
        )
      )}
    </KoncertyStrona>
  );
}

export default KoncertyPage;
